import { Stack } from '@mui/material';
import React from 'react';
import { ListGroup, Form } from 'react-bootstrap';

const NewChildTag = ({
	header,
	childTags,
	childSelection,
	selectedChild = [],
	childChecked,
}) => {
	return (
		<div
			className={`parent_tag`}
			style={{
				marginLeft: '77px',
				marginTop: '-78px',
			}}
		>
			<div
				style={{
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'center',
				}}
			>
				<div className='tag-header1'>
					<h6>{header}</h6>
				</div>
			</div>

			<div className='rounded-pill p-2'>
				<div
					className='overflow-auto'
					style={{ maxHeight: '345px', padding: '0px', width: '243px' }}
				>
					{childTags?.length < 1 ? (
						<p></p>
					) : (
						<ListGroup>
							{selectedChild.length <= 0
								? childTags.map(d1 => (
										<ListGroup.Item
											className='tag ms-2'
											style={{ height: '65px' }}
											key={d1.value}
										>
											<Stack
												direction='row'
												justifyContent='space-between'
												alignItems='center'
												spacing={2}
											>
												{d1.label}{' '}
												<Form.Check
													type='checkbox'
													id={d1.value}
													label=''
													checked={childChecked.includes(d1.value)}
													value={JSON.stringify(d1)}
													onChange={e => childSelection(e, d1)}
												/>
											</Stack>
										</ListGroup.Item>
								  ))
								: selectedChild.map(d1 => (
										<ListGroup.Item
											className='tag  ms-2 selected-parent'
											style={{ padding: '7px', height: '63px' }}
											key={d1.value}
										>
											<Stack
												direction='row'
												justifyContent='space-between'
												alignItems='center'
												spacing={2}
											>
												{d1.label}{' '}
												<Form.Check
													type='checkbox'
													id={d1.value}
													label=''
													checked={childChecked.includes(d1.value)}
													value={JSON.stringify(d1)}
													onChange={e => childSelection(e, d1)}
												/>
											</Stack>
										</ListGroup.Item>
								  ))}
						</ListGroup>
					)}
				</div>
			</div>
		</div>
	);
};

export default NewChildTag;
